import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatherIcon from '../common/FeatherIcon';
import { MAX_PINS } from './usePins';
import './pins.css';

/**
 * The star beside a nav row. Presentational: the sidebar owns the pins hook
 * and passes `pinned` / `onToggle`, so one hook instance serves every row.
 * Hidden until the row is hovered or focused, always visible once pinned.
 */
const NavPinStar = ({ label, pinned = false, full = false, onToggle, className = '' }) => {
  const { t } = useTranslation('nav');
  const blocked = full && !pinned;
  const name = pinned ? t('nav:pins.unpinItem', { label }) : t('nav:pins.pinItem', { label });
  return (
    <button
      type="button"
      className={`nav-pin-star${pinned ? ' is-pinned' : ''}${className ? ` ${className}` : ''}`}
      aria-pressed={pinned}
      aria-label={name}
      aria-disabled={blocked || undefined}
      title={blocked ? t('nav:pins.full', { max: MAX_PINS }) : name}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (blocked || !onToggle) return;
        onToggle();
      }}
    >
      <FeatherIcon name="star" size={14} fill={pinned ? 'currentColor' : 'none'} aria-hidden="true" />
    </button>
  );
};

export default NavPinStar;
